import { createRouter, createWebHashHistory } from 'vue-router'
import index from '../layout/index.vue'
import store from '../store'

const routes = [
  {
    path: '/redirect',
    component: index,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Login',
    tabIsShow: false,
    component: () => import('../views/Login'),
    meta: { title: '后台管理登录' }
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    tabIsShow: true,
    children: [
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404'),
        hidden: true,
        meta: { title: '404', affix: true, noCache: true }
      }
    ]
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: index,
    tabIsShow: false,
    meta: { title: '个人中心' },
    children: [
      {
        path: 'user_center',
        name: 'user_center',
        component: () => import('@/views/user/user_center'),
        meta: { title: '个人中心', activeMenu: "/user_home", noCache: false }
      }
    ]
  },
  {
    path: '/userApp',
    name: 'userApp',
    component: index,
    tabIsShow: false,
    meta: { title: '用户管理' },
    children: [
      {
        path: '/userAppInfo/:uuid',
        name: 'userAppInfo',
        component: () => import('@/views/user/userAppInfo'),
        meta: { title: '用户详情', activeMenu: '/user_home', noCache: false }
      }
    ]
  },
  // {
  //   path: '/downloadLog',
  //   name: 'deviceLog',
  //   component: index,
  //   tabIsShow: false,
  //   meta: { title: '设备管理' },
  //   children: [
  //     {
  //       path: '/deviceLog/download:uuid',
  //       name: 'deviceLogDownload',
  //       component: () => import('../views/equipment/deviceLogDl.vue'),
  //       meta: { title: '设备日志管理', activeMenu: '/device_info', noCache: false }
  //     }
  //   ]
  // },
  {
    path: '/devices',
    name: 'devices',
    component: index,
    tabIsShow: false,
    meta: { title: '设备管理' },
    children: [
      {
        path: 'save/:saveId',
        name: 'deviceSave',
        component: () => import('@/views/equipment/product/productInfo'),
        meta: {
          title: '产品详情',
          activeMenu: '/device_home',
          noCache: false
        }
      }
    ]
  },
  {
    path: '/deviceInfo',
    name: 'deviceInfo',
    component: index,
    tabIsShow: false,
    meta: { title: '设备管理' },
    children: [
      {
        path: 'device_info_list',
        name: 'device_info_list',
        component: () => import('@/views/equipment/equipmentInfoLists'),
        meta: {
          title: '设备详情',
          activeMenu: '/device_info',
          noCache: true
        }
      }
    ]
  },
  {
    path: '/ota_testEqus',
    name: 'ota_testEqus',
    component: index,
    tabIsShow: false,
    meta: { title: '固件管理' },
    children: [
      {
        path: 'ota_testEqu',
        name: 'ota_testEqu',
        component: () => import('@/views/firmware/testEquipment'),
        meta: {
          title: '设备验证',
          activeMenu: '/eq_upload_manage',
          noCache: true
        }
      },
      {
        path: 'ota_Issue',
        name: 'ota_Issue',
        component: () => import('@/views/firmware/upgradeRules'),
        meta: {
          title: '设备验证',
          activeMenu: '/eq_upload_manage',
          noCache: true
        }
      }
    ]
  },
  {
    path: '/application',
    name: 'application',
    component: index,
    tabIsShow: false,
    meta: { title: '应用开发' },
    children: [
      {
        path: '/applicationDpInfo',
        name: 'applicationDpInfo',
        component: () => import('@/views/user/applicationDpInfo'),
        meta: {
          title: '应用开发详情',
          activeMenu: '/applicationDp',
          noCache: false
        }
      }
    ]
  },
  {
    path: '/lindo',
    name: 'lindo',
    component: index,
    tabIsShow: false,
    meta: { title: 'Lindo' },
    children: [
      {
        path: '/lindoEdit',
        name: 'lindoEdit',
        component: () => import('@/views/lindo/problemedit'),
        meta: {
          title: 'Lindo问题编辑',
          activeMenu: '/LindoProblem',
          noCache: false
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
export default router
